/*
 * @Author: PanYunhong
 * @Date: 2022-07-08 13:14:14
 * @LastEditors: Huanglei
 * @LastEditTime: 2023-05-10 10:21:01
 */
import {
  get, post, getRequest, postRequest,
} from '@/request/request';
import axios from 'axios';

/**
 *  街道
 * @param {any} params 参数
 * @returns {any} 结果
 */
export const getStreetList = () => postRequest('/goverance/getStreet');

/**
 *  完成情况
 * @param {any} params 参数
 * @returns {any} 结果
 */
export const getCompletion = () => postRequest('/goverance/getCompletion');

/**
 * 查询项目清单
 * @param {any} params 参数
 * @returns {any} 结果
 */
export const qryProjects = (params:any) => postRequest('/goverance/query', params);

/**
 * 删除项目清单
 * @param {any} params 参数
 * @returns {any} 结果
 */
export const deleteProject = (params:any) => postRequest('/goverance/delete', params);

/**
 * 新增或者编辑项目清单
 * @param {any} params 参数
 * @returns {any} 结果
 */
export const addOrUpdateProject = (params:any) => postRequest('/goverance/addOrUpdate', params);

/**
 * 导入项目清单
 * @param {any} params 参数
 * @returns {any} 结果
 */
export const importProjects = (params:any) => postRequest('/goverance/import', params);

/**
 * 导出项目清单
 * @param {any} params 参数
 * @returns {any} 结果
 */
export const exportProjects = (params:any) => postRequest('/goverance/export', params);
